import { ClipboardList, MessageSquare, UserCheck, Search } from "lucide-react";
import { useLanguage } from "@/hooks/useLanguage";

const HowItWorks = () => {
  const { t } = useLanguage();

  const steps = [
    {
      icon: ClipboardList,
      title: t("how_it_works.step1_title"),
      description: t("how_it_works.step1_desc"),
      color: "bg-primary/10 text-primary",
    },
    {
      icon: Search,
      title: t("how_it_works.step2_title"),
      description: t("how_it_works.step2_desc"),
      color: "bg-warning/10 text-warning",
    },
    {
      icon: MessageSquare,
      title: t("how_it_works.step3_title"),
      description: t("how_it_works.step3_desc"),
      color: "bg-accent/10 text-accent",
    },
    {
      icon: UserCheck,
      title: t("how_it_works.step4_title"),
      description: t("how_it_works.step4_desc"),
      color: "bg-primary/10 text-primary",
    },
  ];

  return (
    <section className="bg-card section-padding">
      <div className="container">
        <div className="mb-12 text-center">
          <p className="text-sm font-semibold uppercase tracking-wider text-primary mb-2">
            {t("how_it_works.overline")}
          </p>
          <h2 className="font-display text-3xl font-bold md:text-4xl">
            {t("how_it_works.title")}
          </h2>
          <p className="mt-3 text-muted-foreground max-w-md mx-auto">
            {t("how_it_works.subtitle")}
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {steps.map((step, index) => (
            <div
              key={index}
              className="group relative rounded-xl border bg-background p-6 transition-all duration-200 hover:border-primary/25 hover:shadow-warm-md hover:-translate-y-0.5"
            >
              <div className="absolute -top-3.5 right-4 flex h-7 w-7 items-center justify-center rounded-full bg-primary text-white font-display text-xs font-bold shadow-warm-sm">
                {index + 1}
              </div>
              <div className={`mb-5 inline-flex h-12 w-12 items-center justify-center rounded-xl ${step.color} transition-transform duration-200 group-hover:scale-110`}>
                <step.icon className="h-6 w-6" aria-hidden="true" />
              </div>
              <h3 className="mb-2 font-display text-base font-semibold leading-snug">{step.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{step.description}</p>
              {index < steps.length - 1 && (
                <div className="absolute right-0 top-1/2 hidden h-px w-6 -translate-y-1/2 translate-x-6 border-t border-dashed border-border lg:block" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
